export default {
	"火蚁联盟": "ファイアアントアライアンス",
	"节点订阅系统": "ノード購読システム",
	"首页": "ホーム",
	"娱乐经济的能量核心": "エンターテインメント経済のエネルギーコア",
	"推荐人：": "紹介者：",
	"我的邀请链接（点击复制）": "私の招待リンク（クリックでコピー）",
	"初级节点": "初級ノード",
	"高级节点": "上級ノード",
	"獲得全網NFT新增業績2.5%分紅": "全ネットワークNFT新規実績の2.5%配当を獲得",
	"获得4倍代币燃料值": "4倍トークン燃料値を獲得",
	"获得5倍代币燃料值": "5倍トークン燃料値を獲得",
	"获得娱乐游戏平台收益的5%分红": "エンターテインメントプラットフォーム収益の5%配当を獲得",
	"获得每日产出FAC代币2%分配": "毎日のFACトークン産出の2%配分を獲得",
	"请连接钱包": "ウォレットを接続してください",
	"USDT余额不足": "USDT残高不足",
	"转账已发起": "送金が開始されました",
	"转账被取消": "送金がキャンセルされました",
	"取消": "キャンセル",
	"未连接钱包": "ウォレット未接続",
	"复制成功": "コピー成功",
	"订单记录": "注文履歴",
	"我的社群": "私のコミュニティ",
	"节点预售": "ノード先行販売",
	"我的订单": "私の注文",
	"创建时间：": "作成時間：",
	"转账哈希：": "送金ハッシュ：",
	"购买初级节点": "初級ノードを購入",
	"购买高级节点": "上級ノードを購入",
	"空": "空",
	"獲得算力挖礦": "算力マイニングを獲得",
	"已购买": "購入済み",
	"獲得DAO投票權限": "DAO投票権を獲得",
	"付款地址：": "支払いアドレス：",
	"節點類型：": "ノードタイプ：",
	"获取中": "取得中",
	"交易中": "取引中",
	"金额：": "金額：",
	"推荐地址：": "紹介アドレス：",
	"推荐时间：": "紹介時間：",
	"社群总业绩 U：": "コミュニティ総実績 U：",
	"社群总地址 个：": "コミュニティ総アドレス数：",
	"确认绑定?": "バインドを確認しますか？",
	"确定": "確定",
	"操作成功": "操作成功",
	"操作失败": "操作失敗",
	"获取数据失败": "データ取得失敗",
	"授权成功": "承認成功",
	"授权失败": "承認失敗",
	"操作中": "操作中",
	"进入共振": "共振に入る",
	"赎回": "償還",
	"领取奖励": "報酬を受け取る",
	"开始共振": "共振開始",
	"共振中，距离共振结束还有": "共振中、共振終了まであと",
	"NFT已经失效": "NFTは既に無効です",
	"超时，NFT即将失效": "タイムアウト、NFTは間もなく無効になります",
	"共振未开始": "共振未開始",
	"赎回共振金": "共振金を償還",
	"共振结束": "共振終了",
	"详情": "詳細",
	"次数：": "回数：",
	"算力：": "算力：",
	"燃料：": "燃料：",
	"剩余用能量：": "残りエネルギー：",
	"总能量：": "総エネルギー：",
	"类型：": "タイプ：",
	"参与共振流动性": "共振流動性に参加",
	"加载中": "読み込み中",
	"未开始": "未開始",
	"共振中": "共振中",
	"异常": "異常",
	"USD资产": "USD資産",
	"FAC资产": "FAC資産",
	"NFT卡牌：": "NFTカード：",
	"共振金：": "共振保証金：",
	"总收益：": "総収益：",
	"共振奖励：": "共振報酬：",
	"直推奖励：": "直接紹介報酬：",
	"层级奖励：": "階層報酬：",
	"社区奖励：": "コミュニティ報酬：",
	"节点分红：": "ノード配当：",
	"已领取：": "受取済み：",
	"我的算力：": "私の算力：",
	"我的燃料：": "私の燃料：",
	"我的矿池：": "私のマイニングプール：",
	"已释放FAC：": "リリース済みFAC：",
	"社区奖励FAC：": "コミュニティ報酬FAC：",
	"节点分红FAC：": "ノード配当FAC：",
	"平台分红FAC：": "プラットフォーム配当FAC：",
	"可领取FAC：": "受取可能FAC：",
	"已领取FAC：": "受取済みFAC：",
	"领取": "受け取る",
	"没有可提取的FAC": "引き出し可能なFACがありません",
	"没有可用的能量": "利用可能なエネルギーがありません",
	"参数获取失败": "パラメータ取得失敗",
	"领取成功": "受取成功",
	"共振奖励提取成功": "共振報酬引き出し成功",
	"共振奖励提取失败": "共振報酬引き出し失敗",
	"层级奖励提取成功": "階層報酬引き出し成功",
	"NFT价格": "NFT価格",
	"数量": "数量",
	"总价": "合計金額",
	"账户余额": "アカウント残高",
	"购买NFT": "NFTを購入",
	"推荐地址": "紹介アドレス",
	"我的邀请链接": "私の招待リンク",
	"复制邀请链接": "招待リンクをコピー",
	"购买失败": "購入失敗",
	"购买成功": "購入成功",
	"我的资产": "私の資産",
	"节点认购": "ノード購入申し込み",
	"时": "時",
	"分": "分",
	"秒": "秒",
	"可领取：": "受け取り可能：",
	"我的能量：": "私のエネルギー：",
	"提取": "抽出",
	"推荐钱包：": "推奨ウォレット：",
	"确认绑定？": "紐づけを確認しますか？",
	"火蚁联盟将于{time}后启动。": "ファイアアントアライアンスは{time}後に開始します。",
	"本操作将在24小时公测期后开放": "この操作は24時間の公開テスト期間後に開放されます",
	"暂未开放": "現在利用できません",
	"请使用分享链接打开。": "共有リンクを使用して開いてください。",
	"Fire Ant Alliance邀请您参与我们的多签。": "Fire Ant Alliance からマルチシグのご招待 トランザクションの確認と署名をお願いします",
	"操作过于频繁": "リクエストが多すぎます",
	"社区奖励提取成功": "コミュニティ報酬の引き出しに成功しました",
	"已释放节点分红FAC：": "リリース済みノード配当FAC：",
	"社群节点总地址 个：": "コミュニティノード総アドレス 個：",
	"社群NFT总地址 个：": "コミュニティNFT総アドレス 個：",
	"NFT业绩 U：": "NFT実績",
	"节点分红释放FAC：": "ノード配当リリース済みFAC：",
	"矿池释放FAC：": "マイニングプールリリース済みFAC：",
	"无剩余能量": "残りエネルギーなし",
}